/**
 * Global context menu manager - ensures only one menu is open at a time
 */
class ContextMenuManager {
    constructor() {
        this.activeMenu = null;
    }

    /**
     * Register that a menu is now open
     * @param {Object} menu - The menu instance (must have a hide() method)
     */
    setActiveMenu(menu) {
        // Close the previously active menu if any
        if (this.activeMenu && this.activeMenu !== menu) {
            this.activeMenu.hide();
        }
        this.activeMenu = menu;
    }

    /**
     * Clear the active menu reference
     */
    clearActiveMenu() {
        this.activeMenu = null;
    }

    /**
     * Hide all menus
     */
    hideAll() {
        if (this.activeMenu) {
            this.activeMenu.hide();
            this.activeMenu = null;
        }
    }
}

// Export a singleton instance
export const contextMenuManager = new ContextMenuManager();
